module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('div', {
    class: [_vm.block + '-container']
  }, [_vm._l((_vm.data.sellers), function(logo, index) {
    return _c('div', {
      class: [_vm.block + '-logo']
    }, [_c('img', {
      class: [_vm.block + '-image'],
      attrs: {
        "src": logo.src,
        "alt": logo.alt
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.data.sellers), function(logo, index) {
    return _c('div', {
      class: [_vm.block + '-logo']
    }, [_c('img', {
      class: [_vm.block + '-image'],
      attrs: {
        "src": logo.src,
        "alt": logo.alt
      }
    })])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18706492","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/LogoList.vue
// module id = 435
// module chunks = 0